module.exports = __webpack_public_path__ + "ubuntu-bolditalic-webfont.a24d3e3a0d0e4a313455.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ubuntu/ubuntu-bolditalic-webfont.woff2
// module id = ./src/assets/webfonts/ubuntu/ubuntu-bolditalic-webfont.woff2
// module chunks = styles